import { inject, Injectable } from '@angular/core';
import { IqTrendlinesSegmentTrackingService } from '@dat/iq-trendlines-ff';
import { UpsellTrackingEventName } from '../../models';

@Injectable({
    providedIn: 'root',
})
export class IqTrendlinesUpsellStateService {
    private _trackingService = inject(IqTrendlinesSegmentTrackingService);
    constructor() {}

    dipstachUpsellSegmentEvent(upsellApp: string): void {
        const props = {
            page: 'Trucking Industry Trends',
            upsell_app: upsellApp,
            location: 'Upsell table',
        };
        this._trackingService.track(UpsellTrackingEventName, props);
    }
}
